


















































































































import {
  Watch, Component, Mixins, ProvideReactive, Prop,
} from 'vue-property-decorator';
import { DataPagination } from 'vuetify';
import {
  Action, State, Mutation,
} from 'vuex-class';
import { CrudOperation } from '@/types/CrudOperation';
import { FilterBuilderInterface } from '@/classes/pimcore-filtering/FilterBuilder';
import EntityHandler from '@/mixins/EntityHandler';
import FormFactoryModal from '@/components/Entity/FormFactoryModal.vue';
import EntityFilters from '@/components/Entity/EntityFilters.vue';
import EntityCrud from '@/classes/EntityCrud';
import {
  PimcoreEntityLayout, PimcoreQueryListingContent,
} from '@/types/entity';
import FormFactory from '@/components/FormBuilder/FormFactory.vue';
import { formatDateForHumanSpecies, formatDateTimeForHumanSpecies } from '@/utils/time';

const pageSize = 10;

@Component({
  components: {
    FormFactoryModal,
    EntityFilters,
    FormFactory,
  },
})
export default class Entity extends Mixins(EntityHandler) {
  @Prop({
    type: Boolean,
    default: true,
  }) readonly actionUpdate!: boolean

  @Prop({
    type: Boolean,
    default: true,
  }) readonly actionDelete!: boolean

  @Prop({
    type: Boolean,
    default: true,
  }) readonly actionCreate!: boolean

  @Prop({
    type: Array,
    default: () => [],
  }) readonly onlyFilters!: Array<string>

  @Prop({
    type: Object,
    default: () => ({}),
  }) readonly complexFiltersVariables!: Record<string, any>

  @Prop({
    type: Array,
    default: () => [],
  }) readonly onlyColumns!: Array<string>

  @Prop({
    type: Array,
    default: () => [],
  }) readonly extendedFilters!: Array<string>

  @Prop({
    type: String,
    default: () => '',
  }) readonly idsFilter!: string

  @Prop({
    type: String,
    required: false,
  }) readonly pageTitle!: string

  @Prop({
    type: String,
    required: false,
  }) readonly localStoragePrefix!: string;

  pagination: DataPagination = {
    page: 1,
    pageStart: 0,
    itemsPerPage: pageSize,
    pageStop: 0,
    pageCount: 0,
    itemsLength: 0,
  };

  loading = true;

  activeFilterBuilder: FilterBuilderInterface | undefined;

  entityCrud!: EntityCrud;

  entityData: any = null;

  updateTimeout: any = null;

  @State('isModalVisible', { namespace: 'entity' })
  readonly isModalVisible!: boolean;

  @State('operation', { namespace: 'entity' })
  readonly operation!: CrudOperation;

  @Action('toggleEntityModal', { namespace: 'entity' })
  toggleEntityModal: any;

  @Mutation('setOperation', { namespace: 'entity' })
  setOperation!: (operation: CrudOperation) => void;

  async beforeMount() {
    this.reloadPageItemsTimeout();
  }

  mounted() {
    this.$bus.$on('entity-refetch', () => {
      this.reloadPageItems();
    });
    this.loading = false;
  }

  beforeDestroy() {
    this.$bus.$off('entity-refetch');
    clearTimeout(this.updateTimeout);
  }

  reloadPageItemsTimeout() {
    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      this.reloadPageItems(true); // silent
      this.reloadPageItemsTimeout();
    }, 10000);
  }

  get entity() {
    return this.$route.params.entityName;
  }

  get isTableLoading() {
    return Boolean(this.$apollo.queries.entityListingData?.loading);
  }

  get createActions() {
    return !!(this.supportedCrudActions.create && this.actionCreate);
  }

  get deleteActions() {
    return !!(this.supportedCrudActions.read && this.actionDelete);
  }

  get updateActions() {
    return !!(this.supportedCrudActions.update && this.actionUpdate);
  }

  get slotActions() {
    return !!this.$scopedSlots.appendActions;
  }

  get showActions() {
    return !!(this.deleteActions || this.updateActions || this.slotActions);
  }

  get title() {
    if (this.pageTitle) {
      return this.pageTitle;
    }
    return this.$t(`${this.entity}_plural`);
  }

  get gridHeadersFiltered() {
    return this.gridHeaders.filter((v) => {
      if (!this.showActions && v.value === 'actions') {
        return false;
      }
      if (this.onlyColumns && this.onlyColumns.length && !this.onlyColumns.includes(v.value)) {
        return false;
      }
      return true;
    });
  }

  @Watch('entity', { immediate: true })
  async onEntityChange(value: string, oldValue: string) {
    if (value !== oldValue) {
      await this.init();
      // this.entityCrud = new EntityCrud(this.entity, this.$apollo);
      this.$data.pagination.page = 1;
      await this.fetchEntityLayouts(value);
    }
  }

  async reloadPageItems(silent = false) {
    if (!silent) this.loading = true;
    const pagination = this.pagination;
    const searchObj: any = { first: pagination.itemsPerPage, after: pagination.pageStart };

    if (this.generateFilters(this.activeFilterBuilder)) {
      searchObj.filter = this.generateFilters(this.activeFilterBuilder);
    }

    if (this.idsFilter) {
      searchObj.ids = this.idsFilter;
    }

    await this.fetchMoreEntityListingData(searchObj);
    this.loading = false;
  }

  async onPagination(pagination: DataPagination, forceReload = false) {
    if (forceReload === false && pagination.itemsPerPage === this.pagination.itemsPerPage && pagination.pageStart === this.pagination.pageStart) {
      return;
    }

    this.pagination = pagination;
    await this.reloadPageItems();
  }

  formatDateForHumanSpecies(value: string) {
    return formatDateForHumanSpecies(value);
  }

  formatDateTimeForHumanSpecies(value: number) {
    return formatDateTimeForHumanSpecies(value);
  }

  selectItem(item: PimcoreQueryListingContent): void {
    this.entityData = this.entityListingData.items.find((listingItem: any) => listingItem.id === item.id);
  }

  handleUpdate(item: any) {
    this.setOperation(CrudOperation.update);
    this.toggleEntityModal(true);
    this.selectItem(item);
  }

  handleDelete(item: any) {
    console.log(item);
  }

  onRowClick(item: PimcoreQueryListingContent) {
    this.selectItem(item);
    this.setOperation(CrudOperation.read);
    this.toggleEntityModal(true);
  }

  onClickCreateButton() {
    this.toggleEntityModal(true);
    this.setOperation(CrudOperation.create);
  }

  async onSearch(filterBuilder: FilterBuilderInterface) {
    this.activeFilterBuilder = filterBuilder;
    if (this.activeFilterBuilder) {
      this.pagination.page = 1;
      this.pagination.pageStart = 0;
    }
    await this.reloadPageItems();
  }
}
